export default __webpack_public_path__ + "static/media/G.e3b3fa06.svg";